import * as React from 'react';
import Pagination from '@mui/material/Pagination';

interface TablePaginationCustomProps {
  tablePage: number;
  amountPages: number;
  setTablePage(x: number): void;
}

const TablePaginationCustom = ({ tablePage, amountPages, setTablePage }: TablePaginationCustomProps) => {
  const handleChangeTablePage = React.useCallback((event: React.ChangeEvent<unknown>, val: number): void => setTablePage(val), [setTablePage]);
  return (
    <Pagination
      size="small"
      sx={{ padding: '1rem', bgcolor: '#ffffff', borderColor: '#ffffff' }}
      page={tablePage}
      onChange={handleChangeTablePage}
      count={Math.ceil(amountPages / 10)}
      variant="outlined"
      shape="rounded"
    />
  );
};

export default TablePaginationCustom;
